import logo from '@/assets/logos/ingleinternational_en.svg';
import type { INamespaceConfig } from '../types';

export const ingleConfig: INamespaceConfig = {
  namespace: 'ingle',
  branding: {
    logoSrc: logo,
    logoAlt: 'Ingle International',
    logoWidth: 175,
    companyName: 'Ingle International',
    appName: 'Customer Portal',
    faviconHref: '/favicon.ico',
  },
  theme: {
    colorPrimary: '#1B1E4D',
    colorSecondary: '#7874B6',
    colorAccent: '#AF557E',
    colorHighlight: '#1DB4D8',
    colorMuted: '#6E6A8D',
    colorLight: '#6BC6E4',
  },
  contact: {
    phone: '1-877-585-8488',
    phoneHref: 'tel:1-877-585-8488',
    internationalPhone: '1-877-585-8488',
    internationalPhoneHref: 'tel:1-877-585-8488',
    email: 'helpline@ingleinternational.com ',
    claimsEmail: 'helpline@ingleinternational.com ',
    legalAssistanceEmail: ' helpline@ingleinternational.com ',
    website: 'https://www.ingleinternational.com',
  },
  features: {
    claims: true,
    faq: true,
  },
  socialLinks: {
    linkedIn: 'https://www.linkedin.com/company/ingle-international/',
    instagram: 'https://www.instagram.com/ingleinternational',
  },
};
